import { inferDateForAmbiguousTime, type TimeConstraints } from "./inferDateForAmbiguousTime";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ClockOutConstraints extends TimeConstraints {}

/**
 * Infers the correct date for an ambiguous clock out time.
 *
 * The time picker only shows hours and minutes (e.g., "11:00 PM"), which creates
 * ambiguity for overnight shifts. For example, in a 10 PM - 2 AM shift:
 * - "11:00 PM" could mean 11 PM on the first day (1 hour shift)
 * - "11:00 PM" could mean 11 PM on the second day (25 hour shift - invalid)
 *
 * This function uses constraints (clock in time, button tap time) to determine
 * which date the user intended.
 *
 * @param ambiguousTime - Time from picker with potentially wrong date
 * @param originalClockOutTime - Original clock out time (provides date context)
 * @param constraints - Constraints to help resolve ambiguity
 * @returns The time with correct date inferred
 */
export function inferDateForAmbiguousClockOutTime(
  ambiguousTime: Date,
  originalClockOutTime: Date,
  constraints: ClockOutConstraints
): Date {
  return inferDateForAmbiguousTime(ambiguousTime, originalClockOutTime, constraints);
}
